module.exports = __webpack_public_path__ + "img/3Moves.4ad857ae.png";